import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Container, Typography } from '@mui/material';

import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';
import PageHeader from '~/components/Common/Elements/PageHeader';

import OffersService from '../../../services/OffersService';
import ReservationService from '../../../services/ReservationService';
import mergeRoomPolicyNames from '../../../utils/mergeRoomPolicyNames';
import RoomPolicyForm from '../../Common/Forms/RoomPolicyForm';

export default function RoomPoliciesEditContainer() {
  const { id_offer: idOffer } = useParams<{ id_offer: string }>();

  const [roomPoliciesWithNames, setRoomPoliciesWithNames] = useState([]);
  const [roomPoliciesSchema, setRoomPoliciesSchema] = useState({});
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    OffersService.getOffer(idOffer).then((response) => {
      setOffer(response.result);
    });
  }, [idOffer]);

  useEffect(() => {
    if (offer) {
      Promise.all([
        OffersService.getRoomPolicySchema(idOffer),
        ReservationService.getProperties(offer.vendor_account_id),
      ]).then(([schemaResponse, propertyResponse]) => {
        const propertyData = propertyResponse.count ? propertyResponse.result : [];

        setRoomPoliciesSchema(schemaResponse.schema);

        const roomPolicies = mergeRoomPolicyNames(offer.packages, propertyData);
        setRoomPoliciesWithNames(roomPolicies);
      });
    }
  }, [idOffer, offer]);

  return (
    <Container>
      <OfferBreadcrumbs offerId={idOffer} currentPage="Room Policies" />
      <PageHeader title="Edit Room Policies" />
      {roomPoliciesWithNames.map((roomPolicy, index) => (
        <Accordion key={index} defaultExpanded={index === 0} sx={{ m: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">{roomPolicy.room_type_name}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <RoomPolicyForm
              key={`${roomPolicy.id}-${roomPolicy.description}`}
              schema={roomPoliciesSchema}
              roomPolicy={roomPolicy}
              idOffer={idOffer}
              offerType={offer?.type}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}
